import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "randmarcomps"
import { OrderDocument as ApiDocument } from "randmar-api-client"
import React from "react"
import { Link } from "react-router-dom"
import Path from "../../routes/Path"
import type { Document as LegacyDocument } from "../../stores/document/Document"
import OpenPDFButton from "../util/OpenPDFButton"

interface IProps {
  documentNumber: string
  applicationId?: string
  document: LegacyDocument | ApiDocument
}

const isLegacy = (doc: LegacyDocument | ApiDocument): doc is LegacyDocument => 'subTotal' in doc;

const getDocumentTitle = (documentNumber: string) => {
  if (documentNumber.startsWith("PO") && documentNumber.length === 9) {
    return "Purchase Order"
  }
  if (documentNumber.startsWith("RQ") && documentNumber.length === 9) {
    return "Requisition"
  }
  if (documentNumber.startsWith("RC") && documentNumber.length === 9) {
    return "Reception"
  }
  return ""
}

const DocumentCard: React.FC<IProps> = ({ documentNumber, applicationId, document: rawDocument }) => {
  const document = React.useMemo(() => {
    if (isLegacy(rawDocument)) {
      return {
        SubTotal: rawDocument.subTotal,
        Location: rawDocument.location,
      };
    }
    return rawDocument;
  }, [rawDocument]);
  const title = getDocumentTitle(documentNumber)

  return (
    <Card>
      <Link
        to={Path.document(applicationId, documentNumber)}
        className="text-gray-700 no-underline hover:text-gray-900 transition-colors"
      >
        <CardHeader className="pb-4 text-center">
          <CardTitle className="text-2xl font-bold">{documentNumber}</CardTitle>
          <CardDescription className="text-base text-muted-foreground">{title}</CardDescription>
        </CardHeader>
      </Link>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="sm:col-span-1">
            <div className="flex h-full flex-col justify-center space-y-4">
              <div className="flex items-center justify-between">
                <p className="font-bold">Sub Total</p>
                <p>
                  {new Intl.NumberFormat("en-CA", {
                    style: "currency",
                    currency: "CAD",
                  }).format(document.SubTotal ?? 0)}
                </p>
              </div>
              <div className="flex items-center justify-between">
                <p className="font-bold">Location</p>
                <p>{document.Location ?? "N/A"}</p>
              </div>
            </div>
          </div>
          <div className="sm:col-span-1 flex items-center justify-center">
            <OpenPDFButton documentNumber={documentNumber} stealth />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default DocumentCard
